// File: src/components/SinglePageMultiStepWizard.jsx
import React, { useState, useEffect } from "react";
import ApiService from "../memberApiServices";

import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";
import ShowToast from "components/ShowToast";
// import ShowToast from "components/ShowToast";


const SinglePageMultiStepWizard = ({ onComplete, initialData = null }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [otp, setOtp] = useState("");
const [otpSent, setOtpSent] = useState(false);
const [otpVerified, setOtpVerified] = useState(false);
const [otpError, setOtpError] = useState("");

  const [formData, setFormData] = useState({
    // Profile data
    name: "",
    email: "",
    mobile: "",
    country: "",
    address: "",
    city: "",
    state: "",
    pin_code: "",
    language: "EN",

    // KYC data
    shop_name: "",
    gst_num: "09AALCR9070K1ZN",
    pan_card: "",
    aadhar_num: "",
    aadhar_front: null,
    aadhar_back: null,
    pan_card_doc: null,
    gst_doc: null,

    // PIN data
    new_pin: "",
    confirm_pin: "",

    // Bank data
    holder_name: "",
    account_number: "",
    confirm_account_number: "",
    bank_name: "",
    ifsc_code: "",
    account_type: "",
    confirm_details: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { userid } = useSession();
  const [serverDocs, setServerDocs] = useState({
    pan_card_pic: null,
    gst_pic: null,
    aadhar_front: null,
    aadhar_back: null,
  });
  
  const steps = [
    {
      id: 1,
      title: "Profile Details",
      subtitle: "Enter your personal information",
      icon: "iconoir-user-circle",
      required: true,
    },
    {
      id: 2,
      title: "KYC Details",
      subtitle: "Upload your documents",
      icon: "iconoir-user-scan",
      required: true,
    },
    {
      id: 3,
      title: "PIN Manager",
      subtitle: "Set up your security PIN",
      icon: "iconoir-lock",
      required: false,
    },
    {
      id: 4,
      title: "Bank Details",
      subtitle: "Add your bank information",
      icon: "iconoir-bank",
      required: true,
    },
  ];
  const handleSendOtp = async () => {
    try {
      const fd = new FormData();
      // fd.append("user_id", userid);
      const res = await fetchWrapper(`https://api.mokshiq.in/get_otp?userid=${userid}`); // your send OTP API
  
      if (res?.status === true) {
        setOtpSent(true);
        setOtpError("");
        ShowToast("OTP sent", "success");
      } else {
        setOtpError("Failed to send OTP");
      }
    } catch {
      setOtpError("Error sending OTP");
    }
  };
  
  const handleVerifyOtp = async () => {
    try {
      const fd = new FormData();
      fd.append("user_id", userid);
      fd.append("otp", otp);
  
      const res = await ApiService.verifyPinOtp(fd); // your verify OTP API
  
      if (res?.status === true) {
        setOtpVerified(true);
        setOtpError("");
        ShowToast("OTP verified", "success");
      } else {
        setOtpError("Invalid OTP");
      }
    } catch {
      setOtpError("Error verifying OTP");
    }
  };
  
  const fetchData = async () => {
    try {
        setLoading(true);
        const response = await fetchWrapper(`https://api.mokshiq.in/get_user_profile?user=${userid}`);
        debugger;
       
       if(response.data.kyc == "waiting_for_confirmation"){
        handleComplete();
       }
       setServerDocs({
        pan_card_pic: response.data.pan_card_pic || null,
        gst_pic: response.data.gst_pic || null,
        aadhar_front: response.data.aadhar_front || null,
        aadhar_back: response.data.aadhar_back || null,
      });
      setFormData(response.data || {});
      
    } catch (err) {
        console.error("Error fetching data:", err);
        ShowToast("Failed to load profile data", "danger");
    } finally {
        setLoading(false);
    }
};

useEffect(() => {
    fetchData();
}, []);

  // Initialize form data with initial values if provided
  useEffect(() => {
    if (initialData) {
      setFormData((prevData) => ({
        ...prevData,
        name: initialData.name || "",
        email: initialData.email || "",
        mobile: initialData.mobile || "",
        country: initialData.country || "",
        address: initialData.address || "",
        city: initialData.city || "",
        state: initialData.state || "",
        pin_code: initialData.pincode || "",
        language: initialData.language || "EN",
        shop_name: initialData.shop_name || "",
        gst_num: initialData.gst_num || "09AALCR9070K1ZN",
        pan_card: initialData.pan_card || "",
        aadhar_num: initialData.aadhar_num || "",
        holder_name: initialData.holder_name || initialData.name || "",
        account_number: initialData.account_number || "",
        bank_name: initialData.bank_name || "",
        ifsc_code: initialData.ifsc_code || "",
      }));
    }
  }, [initialData]);

  // Validation functions
  const validateField = (value, rules) => {
    if (rules.required && (!value || value.toString().trim() === "")) {
      return "This field is required";
    }
    if (rules.minLength && value && value.length < rules.minLength) {
      return `Must be at least ${rules.minLength} characters`;
    }
    if (rules.email && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Please enter a valid email address";
    }
    if (rules.phone && value && !/^[0-9]{10}$/.test(value.replace(/\D/g, ""))) {
      return "Please enter a valid 10-digit phone number";
    }
    if (rules.pattern && value && !rules.pattern.test(value)) {
      return rules.patternMessage || "Invalid format";
    }
    return null;
  };

  const validateCurrentStep = () => {
    const stepErrors = {};

    if (currentStep === 1) {
      // Profile validation
      const profileRules = {
        name: { required: true, minLength: 2 },
        email: { required: true, email: true },
        mobile: { required: true, phone: true },
        country: { required: true },
        address: { required: true, minLength: 10 },
        city: { required: true, minLength: 2 },
        state: { required: true, minLength: 2 },
        pin_code: {
          required: true,
          pattern: /^\d{6}$/,
          patternMessage: "PIN code must be exactly 6 digits",
        },
      };

      Object.keys(profileRules).forEach((field) => {
        const error = validateField(formData[field], profileRules[field]);
        if (error) stepErrors[field] = error;
      });
    } else if (currentStep === 2) {
      // KYC validation
      const kycRules = {
        shop_name: { required: true, minLength: 2 },
        gst_num: {
          required: false,
          
          patternMessage: "Please enter a valid GST number",
        },
        pan_card: {
          required: true,
          pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          patternMessage: "Please enter a valid PAN number",
        },
        aadhar_num: {
          required: true,
          pattern: /^\d{12}$/,
          patternMessage: "Aadhar number must be exactly 12 digits",
        },
      };

      Object.keys(kycRules).forEach((field) => {
        const error = validateField(formData[field], kycRules[field]);
        if (error) stepErrors[field] = error;
      });

      if (!serverDocs.aadhar_front && !formData.aadhar_front)
        stepErrors.aadhar_front = "Aadhar front image is required";
      // if (!formData.aadhar_back)
        if (!serverDocs.aadhar_back && !formData.aadhar_back)
        stepErrors.aadhar_back = "Aadhar back image is required";
      // if (!formData.pan_card_doc)
        if (!serverDocs.pan_card_pic && !formData.pan_card_doc)
        stepErrors.pan_card_doc = "PAN card document is required";
    } else if (currentStep === 3) {
      // PIN validation (optional step) 
      if (formData.new_pin || formData.confirm_pin) {
        if (!formData.new_pin) stepErrors.new_pin = "PIN is required";
        else if (!/^\d{4,6}$/.test(formData.new_pin))
          stepErrors.new_pin = "PIN must be 4-6 digits";

        if (!formData.confirm_pin)
          stepErrors.confirm_pin = "Confirm PIN is required";
        else if (formData.new_pin !== formData.confirm_pin)
          stepErrors.confirm_pin = "PINs do not match";
      }
    } else if (currentStep === 4) {
      // Bank validation
      const bankRules = {
        holder_name: { required: true, minLength: 2 },
        account_number: {
          required: true,
          pattern: /^\d{9,18}$/,
          patternMessage: "Account number must be 9-18 digits",
        },
        confirm_account_number: {
          required: true,
          pattern: /^\d{9,18}$/,
          patternMessage: "Account number must be 9-18 digits",
        },
        bank_name: { required: true, minLength: 2 },
        ifsc_code: {
          required: true,
          pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
          patternMessage: "Please enter a valid IFSC code",
        },
        account_type: { required: true },
      };

      Object.keys(bankRules).forEach((field) => {
        const error = validateField(formData[field], bankRules[field]);
        if (error) stepErrors[field] = error;
      });

      if (formData.account_number !== formData.confirm_account_number) {
        stepErrors.confirm_account_number = "Account numbers do not match";
      }

      if (!formData.confirm_details) {
        stepErrors.confirm_details =
          "Please confirm that the bank details are accurate";
      }
    }

    setErrors(stepErrors);
    return Object.keys(stepErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: null }));
    }
  };

  const handleFileChange = (field, file) => {
    setFormData((prev) => ({ ...prev, [field]: file }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: null }));
    }
  };

  // API call function for each step
  const submitStepData = async (stepNumber) => {
    try {
      let response;

      switch (stepNumber) {
        case 1:
          // Profile Update API Call
          const profileFormData = new FormData();
          profileFormData.append("id", userid);
          profileFormData.append("action", "profile_update");
          profileFormData.append("name", formData.name);
          profileFormData.append("email", formData.email);
          profileFormData.append("mobile", formData.mobile);
          profileFormData.append("country", formData.country);
          profileFormData.append("address", formData.address);
          profileFormData.append("city", formData.city);
          profileFormData.append("state", formData.state);
          profileFormData.append("pin_code", formData.pin_code);
          profileFormData.append("language", formData.language);

          response = await ApiService.updateProfile(profileFormData);
          break;

        case 2:
          // KYC Update API Call
          const kycFormData = new FormData();
          kycFormData.append("id", userid);
          kycFormData.append("action", "kyc_update");
          kycFormData.append("shop_name", formData.shop_name);
          kycFormData.append("gstin", "09AALCR9070K1ZN");
          kycFormData.append("pan_card", formData.pan_card);
          kycFormData.append("aadhar_card", formData.aadhar_num);

          if (formData.aadhar_front)
            kycFormData.append("aadharfront", formData.aadhar_front);
          if (formData.aadhar_back)
            kycFormData.append("aadharback", formData.aadhar_back);
          if (formData.pan_card_doc)
            kycFormData.append("pan", formData.pan_card_doc);
          if (formData.gst_doc) kycFormData.append("gst", formData.gst_doc);

          response = await ApiService.updateKyc(kycFormData);
          break;

        case 3:
          // PIN Change API Call (only if PIN is provided)
          if (formData.new_pin && formData.confirm_pin) {
            const pinData = new FormData();
            pinData.append('otp_pin', formData.new_pin);
            pinData.append('otp',otp );
            pinData.append('user_id', userid);

            response = await ApiService.changePin(pinData);
          } else {
            // Skip PIN step
            return { error: false, data: "PIN step skipped" };
          }
          setCurrentStep(4);
          break;

        case 4:
          // Bank Details Update API Call
          const bankFormData = new FormData();
          bankFormData.append("id", userid);
          bankFormData.append("action", "bank_update");
          bankFormData.append("holder_name", formData.holder_name);
          bankFormData.append("account_number", formData.account_number);
          bankFormData.append("bank_name", formData.bank_name);
          bankFormData.append("bank_ifsc", formData.ifsc_code);
          bankFormData.append("account_type", formData.account_type);
          bankFormData.append("kyc", "waiting_for_confirmation");

          response = await ApiService.updateBankDetails(bankFormData);
          break;

        default:
          throw new Error("Invalid step number");
      }

      return response;
    } catch (error) {
      console.error(`Step ${stepNumber} submission error:`, error);
      return { error: true, data: error.message || "An error occurred" };
    }
  };

  const handleNext = async () => {
    if (!validateCurrentStep()) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Submit current step data
      const response = await submitStepData(currentStep);

      if (response.status === true) {
        // ShowToast(`Step ${currentStep} completed successfully!`, "success");

        if (currentStep < steps.length) {
          // Move to next step
          setCurrentStep(currentStep + 1);
        } else {
          // All steps completed
          handleComplete();
        }
      } else {
        // ShowToast(response.data || "Failed to submit step data", "danger");
      }
    } catch (error) {
      console.error("Step submission error:", error);
      // showToast("An error occurred while submitting data", "danger");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = async () => {
    if (currentStep === 3) {
      setIsSubmitting(true);
      try { 
        // Even when skipping, we might want to log this action
        // const response = await submitStepData(currentStep);
        // if (response.error === false) {
          // showToast("PIN setup skipped", "info");
          setCurrentStep(currentStep + 1);
        // }
      } catch (error) {
        // If skip fails, just move to next step anyway
        setCurrentStep(currentStep + 1);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleComplete = () => {
    if (onComplete) {
      onComplete(formData);
    }
    setCurrentStep(5); // Move to completion step
  };

  // Completion Step
  if (currentStep === 5) {
    return (
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <div className="completed-contents text-center py-5">
              <img
                alt="Success"
                src="../assets/images/form/done.png"
                className="img-fluid mb-4"
                style={{ maxWidth: "200px" }}
              />
              <h4 className="mb-3 text-success">Registration Successful!</h4>
              <p className="text-secondary mb-4">
                Thank you for completing your registration. Your account has
                been created successfully. We'll check your KYC details and activate it as soon as possible.
              </p>
              <button
                className="btn btn-primary btn-lg"
                onClick={() => (window.location.href = "/")}
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container pt-5">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5>Complete Your Registration</h5>
            </div>
            <div className="card-body">
              {/* Step Navigation */}
              {/* <div className="nav custom-navstpes d-flex" role="tablist">
                {steps.map((step) => (
                  <button
                    key={step.id}
                    className={`btn nav-link flex-grow-1 text-center ${
                      currentStep === step.id ? "active" : ""
                    } ${currentStep > step.id ? "completed" : ""}`}
                    onClick={() =>
                      currentStep > step.id && setCurrentStep(step.id)
                    }
                    disabled={currentStep < step.id}
                    type="button"
                  >
                    <span className="d-flex align-items-center">
                      <span>
                        <i className={`${step.icon} pe-2`}></i>
                      </span>
                      <span className="text-start ms-3 custome-title d-flex flex-column">
                        <span className="f-w-500 f-s-16">{step.title}</span>
                        <span className="f-s-14 text-secondary">
                          {step.subtitle}
                        </span>
                      </span>
                    </span>
                  </button>
                ))}
              </div> */}
              <div className="nav custom-navstpes d-flex w-100" role="tablist">
  {steps.map((step) => (
    <button
      key={step.id}
      className={`btn nav-link text-center flex-fill border rounded-0 ${
        currentStep === step.id ? "active" : ""
      } ${currentStep > step.id ? "completed" : ""}`}
      onClick={() => currentStep > step.id && setCurrentStep(step.id)}
      disabled={currentStep < step.id}
      type="button"
    >
      <div className="d-flex align-items-center justify-content-center flex-column">
        <i className={`${step.icon} mb-2`}></i>
        <span className="f-w-500 f-s-16">{step.title}</span>
        <span className="f-s-14 text-secondary">{step.subtitle}</span>
      </div>
    </button>
  ))}
</div>
              <div className="tab-content mt-3">
                <div className="tab-pane fade show active">
                  {/* Step 1: Profile Details */}
                  {currentStep === 1 && (
                    <form
                      className="app-form"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.name ? "is-invalid" : ""
                            }`}
                            type="text"
                            value={formData.name}
                            onChange={(e) =>
                              handleInputChange("name", e.target.value)
                            }
                            placeholder="Enter your full name"
                          />
                          {errors.name && (
                            <div className="invalid-feedback">
                              {errors.name}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            Email Address <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.email ? "is-invalid" : ""
                            }`}
                            type="email"
                            value={formData.email}
                            onChange={(e) =>
                              handleInputChange("email", e.target.value)
                            }
                            placeholder="Enter your email address"
                          />
                          {errors.email && (
                            <div className="invalid-feedback">
                              {errors.email}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            Phone Number <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.mobile ? "is-invalid" : ""
                            }`}
                            type="tel"
                            value={formData.mobile}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              if (numericValue.length <= 10) {
                                handleInputChange("mobile", numericValue);
                              }
                            }}
                            onKeyDown={(e) => {
                              if (
                                !/[0-9]/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Delete" &&
                                e.key !== "Tab"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="Enter 10-digit phone number"
                            maxLength="10"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {errors.mobile && (
                            <div className="invalid-feedback">
                              {errors.mobile}
                            </div>
                          )}
                          <small className="form-text text-muted">
                            Enter exactly 10 digits
                          </small>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            Country <span className="text-danger">*</span>
                          </label>
                          <select
                            className={`form-select ${
                              errors.country ? "is-invalid" : ""
                            }`}
                            value={formData.country}
                            onChange={(e) =>
                              handleInputChange("country", e.target.value)
                            }
                          >
                            <option value="">Select Your Country</option>
                            <option value="IN">India</option>
                            <option value="US">United States</option>
                            <option value="UK">United Kingdom</option>
                            <option value="CA">Canada</option>
                          </select>
                          {errors.country && (
                            <div className="invalid-feedback">
                              {errors.country}
                            </div>
                          )}
                        </div>
                        <div className="col-12 mb-3">
                          <label className="form-label f-w-500">
                            Address <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className={`form-control ${
                              errors.address ? "is-invalid" : ""
                            }`}
                            value={formData.address}
                            onChange={(e) =>
                              handleInputChange("address", e.target.value)
                            }
                            placeholder="Enter your complete address"
                            rows={3}
                          />
                          {errors.address && (
                            <div className="invalid-feedback">
                              {errors.address}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            City <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.city ? "is-invalid" : ""
                            }`}
                            type="text"
                            value={formData.city}
                            onChange={(e) =>
                              handleInputChange("city", e.target.value)
                            }
                            placeholder="Enter your city"
                          />
                          {errors.city && (
                            <div className="invalid-feedback">
                              {errors.city}
                            </div>
                          )}
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label f-w-500">
                            State <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.state ? "is-invalid" : ""
                            }`}
                            type="text"
                            value={formData.state}
                            onChange={(e) =>
                              handleInputChange("state", e.target.value)
                            }
                            placeholder="Enter your state"
                          />
                          {errors.state && (
                            <div className="invalid-feedback">
                              {errors.state}
                            </div>
                          )}
                        </div>
                        <div className="col-md-2 mb-3">
                          <label className="form-label f-w-500">
                            PIN Code <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.pin_code ? "is-invalid" : ""
                            }`}
                            type="text"
                            value={formData.pin_code}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              if (numericValue.length <= 6) {
                                handleInputChange("pin_code", numericValue);
                              }
                            }}
                            onKeyPress={(e) => {
                              if (
                                !/[0-9]/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Delete" &&
                                e.key !== "Tab"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="6-digit PIN"
                            maxLength="6"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {errors.pin_code && (
                            <div className="invalid-feedback">
                              {errors.pin_code}
                            </div>
                          )}
                          <small className="form-text text-muted">
                            Enter exactly 6 digits
                          </small>
                        </div>
                      </div>
                    </form>
                  )}
                  {/* Step 2: KYC Details */}
                  {currentStep === 2 && (
                    <form
                      className="app-form"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <h5 className="mb-3 text-dark f-w-600">
                        Document Information
                      </h5>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            Shop/Business Name{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.shop_name ? "is-invalid" : ""
                            }`}
                            type="text"
                            value={formData.shop_name}
                            onChange={(e) =>
                              handleInputChange("shop_name", e.target.value)
                            }
                            placeholder="Enter shop/business name"
                          />
                          {errors.shop_name && (
                            <div className="invalid-feedback">
                              {errors.shop_name}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            GST Number <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.gst_num ? "is-invalid" : ""
                            }`}
                            type="text"
                            value={formData.gst_num}
                            onChange={(e) =>
                              handleInputChange(
                                "gst_num",
                                e.target.value.toUpperCase()
                              )
                            }
                            placeholder="22AAAAA0000A1Z5"
                            maxLength="15"
                          />
                          {errors.gst_num && (
                            <div className="invalid-feedback">
                              {errors.gst_num}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            PAN Card Number{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.pan_card ? "is-invalid" : ""
                            }`}
                            type="text"
                            value={formData.pan_card}
                            onChange={(e) =>
                              handleInputChange(
                                "pan_card",
                                e.target.value.toUpperCase()
                              )
                            }
                            placeholder="AAAAA0000A"
                            maxLength="10"
                          />
                          {errors.pan_card && (
                            <div className="invalid-feedback">
                              {errors.pan_card}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            Aadhar Number <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.aadhar_num ? "is-invalid" : ""
                            }`}
                            type="text"
                            value={formData.aadhar_num}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              if (numericValue.length <= 12) {
                                handleInputChange("aadhar_num", numericValue);
                              }
                            }}
                            onKeyPress={(e) => {
                              if (
                                !/[0-9]/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Delete" &&
                                e.key !== "Tab"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="123456789012"
                            maxLength="12"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {errors.aadhar_num && (
                            <div className="invalid-feedback">
                              {errors.aadhar_num}
                            </div>
                          )}
                          <small className="form-text text-muted">
                            Enter exactly 12 digits
                          </small>
                        </div>
                        <div className="col-12">
                          <hr />
                        </div>
                        <h5 className="mb-3 text-dark f-w-600">
                          Upload Documents
                        </h5>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            Aadhar Card Front{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.aadhar_front ? "is-invalid" : ""
                            }`}
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            onChange={(e) =>
                              handleFileChange(
                                "aadhar_front",
                                e.target.files[0]
                              )
                            }
                          />
                          {errors.aadhar_front && (
                            <div className="invalid-feedback">
                              {errors.aadhar_front}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            Aadhar Card Back{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.aadhar_back ? "is-invalid" : ""
                            }`}
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            onChange={(e) =>
                              handleFileChange("aadhar_back", e.target.files[0])
                            }
                          />
                          {errors.aadhar_back && (
                            <div className="invalid-feedback">
                              {errors.aadhar_back}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            PAN Card <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.pan_card_doc ? "is-invalid" : ""
                            }`}
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            onChange={(e) =>
                              handleFileChange(
                                "pan_card_doc",
                                e.target.files[0]
                              )
                            }
                          />
                          {errors.pan_card_doc && (
                            <div className="invalid-feedback">
                              {errors.pan_card_doc}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label f-w-500">
                            GST Document
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            onChange={(e) =>
                              handleFileChange("gst_doc", e.target.files[0])
                            }
                          />
                        </div>
                      </div>
                    </form>
                  )}
                  {/* Step 3: PIN Manager */}
                  {currentStep === 3 && (
                    <div className="card security-card-content">
                      <div className="card-body">
                        <div className="row align-items-center mb-4">
                          <div className="col-9">
                            <h5 className="text-primary f-w-600">
                              Set Up Security PIN
                            </h5>
                            <p className="text-secondary">
                              Create a secure 4-6 digit PIN for transactions.
                              You can skip this step and set it up later.
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label f-w-500">
                              New PIN
                            </label>
                            <input
                              className={`form-control ${
                                errors.new_pin ? "is-invalid" : ""
                              }`}
                              type="password"
                              value={formData.new_pin}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                if (numericValue.length <= 6) {
                                  handleInputChange("new_pin", numericValue);
                                }
                              }}
                              onKeyPress={(e) => {
                                if (
                                  !/[0-9]/.test(e.key) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Delete" &&
                                  e.key !== "Tab"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder="Enter 4-6 digit PIN"
                              maxLength="6"
                              inputMode="numeric"
                              pattern="[0-9]*"
                            />
                            {errors.new_pin && (
                              <div className="invalid-feedback">
                                {errors.new_pin}
                              </div>
                            )}
                            <small className="form-text text-muted">
                              Enter 4-6 digits only
                            </small>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label f-w-500">
                              Confirm PIN
                            </label>
                            <input
                              className={`form-control ${
                                errors.confirm_pin ? "is-invalid" : ""
                              }`}
                              type="password"
                              value={formData.confirm_pin}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                if (numericValue.length <= 6) {
                                  handleInputChange(
                                    "confirm_pin",
                                    numericValue
                                  );
                                }
                              }}
                              onKeyPress={(e) => {
                                if (
                                  !/[0-9]/.test(e.key) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Delete" &&
                                  e.key !== "Tab"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder="Re-enter PIN"
                              maxLength="6"
                              inputMode="numeric"
                              pattern="[0-9]*"
                            />
                            {errors.confirm_pin && (
                              <div className="invalid-feedback">
                                {errors.confirm_pin}
                              </div>
                            )}
                            <small className="form-text text-muted">
                              Must match the PIN above
                            </small>
                          </div>
                          {/* Send OTP button */}
      {!otpSent && (
       <div className="mb-3">
        <button className="btn btn-success mt-2" onClick={handleSendOtp}>
       Verify OTP
     </button>
       </div>
      )}

      {/* OTP input + verify */}
      {otpSent && !otpVerified && (
        <div className="mb-3">
          <label className="form-label f-w-500">Enter OTP</label>
          <input
            type="text"
            className={`form-control ${otpError ? "is-invalid" : ""}`}
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0,6))}
            placeholder="Enter received OTP"
            maxLength={6}
          />
          {otpError && <div className="invalid-feedback">{otpError}</div>}

          
        </div>
      )}
                          <div className="col-12">
                            <div className="alert alert-info">
                              <i className="ti ti-info-circle me-2"></i>
                              <strong>Optional Step:</strong> You can skip this
                              step and set up your PIN later from account
                              settings.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Step 4: Bank Details */}
                  {currentStep === 4 && (
                    <div className="card security-card-content">
                      <div className="card-body">
                        <div className="row align-items-center mb-4">
                          <div className="col-9">
                            <h5 className="text-primary f-w-600">
                              Add Bank Details
                            </h5>
                            <p className="text-secondary">
                              Provide your bank account information for fund
                              transfers and transactions.
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 mb-3">
                            <label className="form-label f-w-500">
                              Account Holder Name{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              className={`form-control ${
                                errors.holder_name ? "is-invalid" : ""
                              }`}
                              type="text"
                              value={formData.holder_name}
                              onChange={(e) =>
                                handleInputChange("holder_name", e.target.value)
                              }
                              placeholder="Enter account holder name"
                            />
                            {errors.holder_name && (
                              <div className="invalid-feedback">
                                {errors.holder_name}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label f-w-500">
                              Account Number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              className={`form-control ${
                                errors.account_number ? "is-invalid" : ""
                              }`}
                              type="text"
                              value={formData.account_number}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                handleInputChange(
                                  "account_number",
                                  numericValue
                                );
                              }}
                              onKeyPress={(e) => {
                                if (
                                  !/[0-9]/.test(e.key) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Delete" &&
                                  e.key !== "Tab"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder="Enter account number"
                              inputMode="numeric"
                              pattern="[0-9]*"
                            />
                            {errors.account_number && (
                              <div className="invalid-feedback">
                                {errors.account_number}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label f-w-500">
                              Confirm Account Number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              className={`form-control ${
                                errors.confirm_account_number
                                  ? "is-invalid"
                                  : ""
                              }`}
                              type="text"
                              value={formData.confirm_account_number}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                handleInputChange(
                                  "confirm_account_number",
                                  numericValue
                                );
                              }}
                              onKeyPress={(e) => {
                                if (
                                  !/[0-9]/.test(e.key) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Delete" &&
                                  e.key !== "Tab"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder="Re-enter account number"
                              inputMode="numeric"
                              pattern="[0-9]*"
                            />
                            {errors.confirm_account_number && (
                              <div className="invalid-feedback">
                                {errors.confirm_account_number}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label f-w-500">
                              Bank Name <span className="text-danger">*</span>
                            </label>
                            <input
                              className={`form-control ${
                                errors.bank_name ? "is-invalid" : ""
                              }`}
                              type="text"
                              value={formData.bank_name}
                              onChange={(e) =>
                                handleInputChange("bank_name", e.target.value)
                              }
                              placeholder="Enter bank name"
                            />
                            {errors.bank_name && (
                              <div className="invalid-feedback">
                                {errors.bank_name}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label f-w-500">
                              IFSC Code <span className="text-danger">*</span>
                            </label>
                            <input
                              className={`form-control ${
                                errors.ifsc_code ? "is-invalid" : ""
                              }`}
                              type="text"
                              value={formData.ifsc_code}
                              onChange={(e) =>
                                handleInputChange(
                                  "ifsc_code",
                                  e.target.value.toUpperCase()
                                )
                              }
                              placeholder="Enter IFSC code"
                              maxLength="11"
                            />
                            {errors.ifsc_code && (
                              <div className="invalid-feedback">
                                {errors.ifsc_code}
                              </div>
                            )}
                          </div>
                          <div className="col-12 mb-3">
                            <label className="form-label f-w-500">
                              Account Type{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className={`form-select ${
                                errors.account_type ? "is-invalid" : ""
                              }`}
                              value={formData.account_type}
                              onChange={(e) =>
                                handleInputChange(
                                  "account_type",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select Account Type</option>
                              <option value="savings">Savings Account</option>
                              <option value="current">Current Account</option>
                              <option value="salary">Salary Account</option>
                            </select>
                            {errors.account_type && (
                              <div className="invalid-feedback">
                                {errors.account_type}
                              </div>
                            )}
                          </div>
                          <div className="col-12 mb-3">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="bankDetailsConfirm"
                                checked={formData.confirm_details}
                                onChange={(e) =>
                                  handleInputChange(
                                    "confirm_details",
                                    e.target.checked
                                  )
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="bankDetailsConfirm"
                              >
                                I confirm that the above bank details are
                                accurate and belong to me.{" "}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                            {errors.confirm_details && (
                              <div className="text-danger f-s-12 mt-1">
                                {errors.confirm_details}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Navigation Buttons */}
                  <div className="mt-4 d-flex justify-content-between">
                    <div>
                      {currentStep > 1 && (
                        <button
                          className="btn btn-outline-secondary btn-lg"
                          onClick={handlePrevious}
                          disabled={isSubmitting}
                        >
                          Previous
                        </button>
                      )}
                    </div>
                    <div>
                      {currentStep === 3 && (
                        <button
                          className="btn btn-outline-primary btn-lg me-2"
                          onClick={handleSkip}
                          disabled={isSubmitting}
                        >
                          Skip
                        </button>
                      )}
                      <button
                        className="btn btn-primary btn-lg"
                        onClick={handleNext}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Processing...
                          </>
                        ) : currentStep === steps.length ? (
                          "Submit"
                        ) : (
                          "Next"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SinglePageMultiStepWizard;
